<template>
    <div class="page-user-edit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">會員管理</div>
            <div class="breadcrumb-item">修改資料</div>
        </div>

        <div class="pg-block">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Row>
                    <Col span="18" push="5">
                        <Form :label-width="150">
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>會員名稱</span>
                                        </div>
                                        <Input v-model="form.username" disabled />
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <!-- <em class="red">* </em> -->
                                            <span>聯絡電話</span>
                                        </div>
                                        <Input v-model="form.phone" disabled />
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <!-- <em class="red">* </em> -->
                                            <span>總積分</span>
                                        </div>
                                        <Input v-model="form.integral" disabled />
                                    </FormItem>
                                </Col>
                                <!--<Col span="10">
                                <div class="explain-label">其中贈送積分10</div>
                                </Col>-->
                            </Row>

                           <Row :gutter="15">
                              <Col span="14">
                                 <FormItem label="用户类型">
                                    <RadioGroup v-model="form.user_type">
                                       <Radio label="1">一般用户</Radio>
                                       <Radio label="2">BTB用户</Radio>
                                       <Radio label="3">其他用户</Radio>
                                       <Radio label="4">核销商户</Radio>
                                    </RadioGroup>
                                 </FormItem>
                              </Col>
                           </Row>

                           <Row :gutter="15">
                              <Col span="14">
                                 <FormItem>
                                    <div slot="label" class="form-label">
                                        <em class="red">* </em>
                                       <span>结算天数</span>
                                    </div>
                                    <Input v-model="form.user_order_type" />
                                 </FormItem>
                              </Col>
                           </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>提貨櫃點</span>
                                        </div>
                                        <Select v-model="form.cabinet_id" placeholder="請選擇門店/智能櫃">
                                            <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                                                    :key="item.ReceivingID">({{item.cainiao_match}}) {{item.ReceivingName}}
                                            </Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                            </Row>

                            <FormItem>
                                <div class="pg-btn-wrap">
                                    <div class="pg-btn style1" @click="handleCheckForm">修改</div>
                                    <div class="pg-btn" @click="handleBack">返回</div>
                                    <!-- <Button type="error" :loading="true" class="loading-btn">
                                         <span>Loading...</span>
                                     </Button>-->
                                </div>
                            </FormItem>

                        </Form>
                    </Col>

                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                pageParam: {},
                pickAddress: [],    //提貨櫃點
                detail: {},
                isSubmiting: false,
                form: {
                    username: '',
                    phone: '',
                    integral: '',
                    cabinet_id: '',    //提货柜点id
                   user_type: '',
                   user_order_type: ''
                }
            };
        },
        mounted()
        {
            this.pageParam = this.$route.query;
            this.getDetail();
            this.getPickAddress();
        },
        methods: {
            handleBack()
            {
                this.$router.go(-1);
            },
            //提貨櫃點
            getPickAddress()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAddress,
                    method: 'get',
                    data: {
                        company_id: 0,
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.pickAddress = res.data.data.filter(it=>it.company_id != 15);
                    }
                });
            },
            getDetail()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.userList + '/' + this.pageParam.id,
                    method: 'get'
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        let resData = res.data;
                        this.form = {
                            username: resData.user_name,
                            phone: resData.phone,
                            integral: resData.user_integral,
                            cabinet_id: resData.cabinet_id,
                            user_type: resData.user_type.toString()
                        };
                    }
                });
            },

            handleCheckForm()
            {
                let form = this.form;

                this.handleSubmit();

            },
            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.userUpdate_new,
                    method: 'post',
                    data: {
                       user_id: this.pageParam.id,
                       store_id: Number(form.cabinet_id),
                       user_type: form.user_type,
                       user_order_type: form.user_order_type
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        this.$Utils.showSuccess(res.msg);
                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "UserEdit.scss";
</style>
